import {
  FetchCompanyTabsCacheKey,
  FetchCompanyTabsFilters,
  FetchCompanyTabsGqlQuery,
  FetchCompanyTabsLimit,
  FetchCompanyTabsPage,
  FetchCompanyTabsSort
} from '../../companyTabsTypes';

import { IndexQueryDefaultOptionsOpts } from '../../../common/reactQuery/hooks/useIndexQuery';
import { useEdIndexQuery } from '../../../common/reactQuery/hooks/useEdIndexQuery';

import {
  INITIAL_COMPANY_TABS_FILTERS,
  INITIAL_COMPANY_TABS_LIMIT,
  INITIAL_COMPANY_TABS_PAGE,
  INITIAL_COMPANY_TABS_SORT
} from '../../companyTabsConstants';

interface CompanyTabsOptions<NodeType> {
  cacheKey: FetchCompanyTabsCacheKey;
  initialFilters?: FetchCompanyTabsFilters;
  initialSort?: FetchCompanyTabsSort;
  initialPage?: FetchCompanyTabsPage;
  initialLimit?: FetchCompanyTabsLimit;
  options?: IndexQueryDefaultOptionsOpts<NodeType>;
  query: FetchCompanyTabsGqlQuery;
}

const scope = 'companyTabs';

function useCompanyTabs<NodeType>({
  cacheKey,
  initialFilters = INITIAL_COMPANY_TABS_FILTERS,
  initialSort = INITIAL_COMPANY_TABS_SORT,
  initialPage = INITIAL_COMPANY_TABS_PAGE,
  initialLimit = INITIAL_COMPANY_TABS_LIMIT,
  options = {},
  query
}: CompanyTabsOptions<NodeType>) {
  const {
    data,
    items,
    itemsError,
    itemsErrorMessage,
    itemsTotalCount,
    isFetched,
    isLoading,
    isPlaceholderData,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    updateItemCache,
    updateItemsCache,
    filterItems,
    changeItemsFilters,
    clearItemsFilters,
    sortItems,
    paginateItems,
    limitItems,
    prefetchItems
  } = useEdIndexQuery<NodeType>({
    cacheKey,
    scope,
    initialFilters,
    initialLimit,
    initialPage,
    initialSort,
    options,
    query
  });

  return {
    companyTabsData: data,
    companyTabs: items,
    companyTabsError: itemsError,
    companyTabsErrorMessage: itemsErrorMessage,
    companyTabsTotalCount: itemsTotalCount,
    companyTabsFetched: isFetched,
    companyTabsLoading: isLoading,
    companyTabsIsPlaceholderData: isPlaceholderData,
    companyTabsFilters: currentFilters,
    companyTabsSort: currentSort,
    companyTabsPage: currentPage,
    companyTabsLimit: currentLimit,
    updateCompanyTabCache: updateItemCache,
    updateCompanyTabsCache: updateItemsCache,
    filterCompanyTabs: filterItems,
    changeCompanyTabsFilters: changeItemsFilters,
    clearCompanyTabsFilters: clearItemsFilters,
    sortCompanyTabs: sortItems,
    paginateCompanyTabs: paginateItems,
    limitCompanyTabs: limitItems,
    prefetchCompanyTabs: prefetchItems
  };
}

export default useCompanyTabs;
